import { render, staticRenderFns } from "./DistributeDataMonitor.vue?vue&type=template&id=0a1ad8b1&scoped=true&"
import script from "./DistributeDataMonitor.vue?vue&type=script&lang=js&"
export * from "./DistributeDataMonitor.vue?vue&type=script&lang=js&"
import style0 from "./DistributeDataMonitor.vue?vue&type=style&index=0&id=0a1ad8b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1ad8b1",
  null
  
)

export default component.exports